/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Twitter/theme';

export const TwitterTheme = theme;
